export default __webpack_public_path__ + "d97d634de8170bab4bb738e98b2bf4f9.svg";